import getAuthUser from "./get-auth-user";

function waitForAuthChannelSocket(authChannel) {
  if (authChannel?.socket) return Promise.resolve();

  return new Promise(resolve => {
    const interval = setInterval(() => {
      if (authChannel?.socket) {
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });
}

export async function completeMetaverseLoginAfterBridge({
  store,
  authChannel,
  hubChannel,
  dashboardToken,
  loadAuthUser = token => getAuthUser(store, false, true, "?profile=true", { token }),
  waitForSocket = true
}) {
  if (!dashboardToken) {
    return { status: "missing_token" };
  }

  const user = await loadAuthUser(dashboardToken);
  if (!user?.email) {
    return { status: "missing_user", user };
  }

  if (user.is_duplicate) {
    return { status: "duplicate", user };
  }

  if (waitForSocket) {
    await waitForAuthChannelSocket(authChannel);
  }

  const { authComplete } = await authChannel.startAuthentication(user.email, hubChannel, dashboardToken);
  await authComplete;

  return { status: "signed_in", user };
}
